import { type QueryHookOptions, useQuery } from "@apollo/client";
import { TagTypesAutocompleteQuery } from "../graphql/queries";
import type {
  TagTypesAutocompleteQueryType,
  TagTypesAutocompleteQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useTagTypesAutocompleteQuery = (
  options?: QueryHookOptions<
    TagTypesAutocompleteQueryType,
    TagTypesAutocompleteQueryVariablesType
  >
) => {
  return useQuery<
    TagTypesAutocompleteQueryType,
    TagTypesAutocompleteQueryVariablesType
  >(TagTypesAutocompleteQuery, options);
};
